import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductWithMultipleLadders } from '../../../classes/customer-segment/adoption-ladder.class';
import { RX_ALL_PRODUCTS_ID } from '../rx-trends/rx-trends.aggregate';

/**
 * The journey tab's product pill row: a pinned All pill, then ours, then the
 * competitors'. Rendered both at the top of the tab and inside the Rx trends
 * fullscreen modal, which is why it lives here rather than in either template.
 *
 * Which pill reads as active comes in as its own input rather than off the
 * pills' `selected` flag: both hosts pass the same array instance, so a
 * selection made in one is a mutation the other's OnPush check never sees.
 */
@Component({
  selector: 'product-pill-row',
  templateUrl: './product-pill-row.html',
  styleUrls: ['./product-pill-row.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPillRowComponent {
  @Input() pills: ProductWithMultipleLadders[] = [];
  @Input() activePillId: string | null = null;
  @Output() pillSelect = new EventEmitter<ProductWithMultipleLadders>();

  get allProductsPill(): ProductWithMultipleLadders | undefined {
    return this.pills.find(pill => pill.id === RX_ALL_PRODUCTS_ID);
  }

  get ownProductPills(): ProductWithMultipleLadders[] {
    return this.pills.filter(pill => pill.id !== RX_ALL_PRODUCTS_ID && !pill.isCompetitorProduct);
  }

  get competitorProductPills(): ProductWithMultipleLadders[] {
    return this.pills.filter(pill => pill.id !== RX_ALL_PRODUCTS_ID && pill.isCompetitorProduct);
  }
}
